var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheatreMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.84 74.73H23.16A17.87 17.87 0 0 1 5.31 56.88v-33A17.87 17.87 0 0 1 23.16 6h53.68a17.87 17.87 0 0 1 17.85 17.85v33a17.87 17.87 0 0 1-17.85 17.88zM23.16 12.79A11.07 11.07 0 0 0 12.1 23.85v33a11.07 11.07 0 0 0 11.06 11.09h53.68A11.07 11.07 0 0 0 87.9 56.88v-33a11.07 11.07 0 0 0-11.06-11.09zM31.16 94a3.39 3.39 0 0 1-1.85-6.24c21.3-13.82 40.67-.5 41.49.07a3.4 3.4 0 0 1-3.91 5.55c-.65-.46-16.51-11.2-33.88.07a3.37 3.37 0 0 1-1.85.55z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatreMode);
export default __webpack_public_path__ + "static/media/theatre-mode.498efe1d490ef5862c51d959e27c98d1.svg";
export { ForwardRef as ReactComponent };